import * as React from "react";
import { useNavigate } from "react-router";
import { motion } from "motion/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import banner1 from "../assets/banner1.png";
import banner2 from "../assets/banner2.png";

function Banner() {
  const [animate, setAnimate] = React.useState(false);
  let navigate = useNavigate();
  function SampleNextArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-next-arrow" onClick={onClick}>
        <FontAwesomeIcon icon={faAngleRight} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-prev-arrow" onClick={onClick}>
        <FontAwesomeIcon icon={faAngleLeft} />
      </div>
    );
  }
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    lazyLoad: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    swipeToSlide: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    afterChange: () => {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 2000);
    },
  };

  const slides = [
    {
      id: 1,
      // img: "https://panachewears.in/assets/images/banner/2.jpg",
      img: banner1,
      title1: "Outfits for Wedding ",
      title2: {
        prefix: "SOYARA IS YOUR PERFECT WEDDING WARDROBE",
        highlight: "",
        suffix: "",
      },
      desc: "Outfits & accessories for the Bride, Groom & their entire squad.",
      btnText: "Explore More",
    },
    {
      id: 2,
      img: banner2,
      // title1: "Royal Wedding Venues",
      // title2: {
      //   prefix: "MAKE YOUR",
      //   highlight: "BIG DAY",
      //   suffix: "TRULY GRAND!",
      // },
      // desc: "Discover curated wedding venues — from palace lawns to heritage halls, fully customizable.",
      // btnText: "Book Wedding Venue",
    },
    // {
    //   id: 3,
    //   img: "https://panachewears.in/assets/images/banner/women5.jpg",
    //   title1: "Elegant Engagement Spots",
    //   title2: {
    //     prefix: "CELEBRATE YOUR",
    //     highlight: "ENGAGEMENT",
    //     suffix: "IN STYLE!",
    //   },
    //   desc: "From cozy lounges to scenic terraces — find the right space to mark your new beginning.",
    //   btnText: "Find Engagement Venues",
    // },
    // {
    //   id: 4,
    //   img: "https://panachewears.in/assets/images/banner/banner2.jpg",
    //   title1: "Maternity Shoots",
    //   title2: {
    //     prefix: "CAPTURE THE",
    //     highlight: "MAGIC",
    //     suffix: "OF MOTHERHOOD!",
    //   },
    //   desc: "Rent peaceful, aesthetic spaces for timeless maternity photo shoots.",
    //   btnText: "Browse Maternity Spots",
    // },
  ];

  function showProdDetail() {
    navigate("/product_details");
  }
  const parentVarient = {
    initial: { opacity: 0 },
    onView: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.4,
      },
    },
  };

  const childrenVariant = {
    initial: { opacity: 0, y: 100 },
    onView: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 40,
        damping: 4,
      },
    },
  };

  return (
    // <div style={{ width: "100%",height:'100vh' }}>
    //   <div className="banner-container">
    //     {/* <h3 className="category-title" >TOP CATEGORIES</h3> */}
    //     <Slider {...settings} className="banner-slider">
    //       {slides.map(function (item, index) {
    //         return (
    //           <div
    //           className="banner-item" key={item.id}>
    //             <img src={item.img} />
    //             <div className={`banner-info ${animate ? "animate" : ""}`}>
    //               <h4>{item.title1}</h4>
    //               <h1>{item.title2}</h1>
    //               <button type="button" className="shop-now-btn">
    //                 <b>Explore NOW</b>
    //               </button>
    //             </div>
    //           </div>
    //         );
    //       })}
    //     </Slider>
    //   </div>
    // </div>

    <div style={{ width: "100%" }}>
      <div className="banner-container">
        {/* <h3 className="category-title" >TOP CATEGORIES</h3> */}
        <Slider {...settings}>
          {slides.map((item) => (
            <div className="banner-slide" key={item.id}>
              <motion.div
                className="banner-left"
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                <motion.img
                  src={item.img}
                  alt={item.title1}
                  lazyLoad="lazy"
                  className="banner-img"
                  whileHover={{ scale: 1.05 }}
                  transition={{ type: "spring", stiffness: 200 }}
                />
                {item?.title1?.length > 0 && (
                  <motion.div
                    className="banner-right"
                    variants={parentVarient}
                    initial="initial"
                    whileInView="onView"
                  >
                    <motion.h4 variants={childrenVariant}>
                      {item.title1}
                    </motion.h4>
                    <motion.h1 variants={childrenVariant}>
                      {item.title2.prefix}{" "}
                      <span className="highlight">{item.title2.highlight}</span>{" "}
                      {item.title2.suffix}
                    </motion.h1>
                    <motion.p variants={childrenVariant}>{item.desc}</motion.p>
                    <motion.button
                      variants={childrenVariant}
                      className="shop-now-btn"
                      onClick={()=> navigate('/product_list/2') }
                    >
                      <b>{item.btnText}</b>
                    </motion.button>
                  </motion.div>
                )}
              </motion.div>
            </div>

            // <div className="banner-slide" key={item.id}>
            //   <motion.div
            //     className="banner-left"
            //     initial={{ x: -100, opacity: 0 }}
            //     whileInView={{ x: 0, opacity: 1 }}
            //     transition={{ duration: 0.8, ease: "easeOut" }}
            //   >
            //     <motion.img
            //       src={item.img}
            //       alt={item.title1}
            //       className="banner-img"
            //       whileHover={{ scale: 1.05 }}
            //       transition={{ type: "spring", stiffness: 200 }}
            //     />
            //   </motion.div>

            //   <motion.div
            //     className="banner-right"
            //     variants={parentVarient}
            //     initial="initial"
            //     whileInView="onView"
            //   >
            //     <motion.h4 variants={childrenVariant}>{item.title1}</motion.h4>
            //     <motion.h1 variants={childrenVariant}>
            //       {item.title2.prefix}{" "}
            //       <span className="highlight">{item.title2.highlight}</span>{" "}
            //       {item.title2.suffix}
            //     </motion.h1>
            //     <motion.p variants={childrenVariant}>{item.desc}</motion.p>
            //     <motion.button
            //       variants={childrenVariant}
            //       className="shop-now-btn"
            //     >
            //       <b>{item.btnText}</b>
            //     </motion.button>
            //   </motion.div>
            // </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
export default Banner;
